import React from 'react';
import PageData, { PageType } from '../models/PageData';
import { SENDER_ACTIONS, SESSIONDATA, SESSIONSTATE } from '../models/Engine';
import ApplicationStore from './ApplicationStore';
import { LOG_TYPE } from '../models/Log';

const idlePages = [
  PageType.SCREEN_ADMIN,
  PageType.SCREEN_ADMIN_VEND,
  PageType.SCREEN_DEFAULT,
  PageType.SCREEN_DEVICE_OUT_OF_STOCK,
  PageType.SCREEN_IDLE,
  PageType.SCREEN_INVENTORY,
  PageType.SCREEN_STATUS,
  PageType.SCREEN_OFFLINE,
];

function useSessionHandler(activePageId: string | null, pages: PageData[], scripts?: { [key: string]: string }): ApplicationStore {
  const [session, setSession] = React.useState<SESSIONSTATE>('INIT');
  const [data, setData] = React.useState<SESSIONDATA>({});
  const [hasStarted, setHasStarted] = React.useState(false);

  const store = React.useMemo(() => new ApplicationStore(scripts ?? {}, pages), [scripts, session, pages]);

  React.useEffect(() => {
    store.on('DATA_CHANGED', handleDataChange);
    return () => {
      store.off('DATA_CHANGED', handleDataChange);
    };
  }, [store]);

  const handleDataChange = () => {
    setData(store.data);
  };

  React.useEffect(() => {
    if (activePageId && idlePages.includes(activePageId as PageType)) {
      setSession('IDLE');
    }
    if(activePageId && !idlePages.includes(activePageId as PageType)) {
      if(!hasStarted) {
          setHasStarted(true);
      }
      setSession('ACTIVE');
    }
  }, [activePageId]);

  React.useEffect(() => {
    if (session === 'ACTIVE') {
      window.SENDER({ type: SENDER_ACTIONS.SESSION_START, payload: '' });
    }
    if (session === 'IDLE' && hasStarted) {
      window.LOGGER({ type: LOG_TYPE.DATA_CAPTURE, payload: JSON.stringify(data) });
      window.SENDER({ type: SENDER_ACTIONS.SESSION_RESET, payload: '' });
    }
  }, [session]);

  return store;
}

export default useSessionHandler;
